module.exports = __webpack_public_path__ + "media/bootstrap-icons/check-square-d3632c66.svg";